import axios from "axios";
import { useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LoginView = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // Here you could add validation or API call to test credentials if needed
      if (!username || !apiKey) {
        throw new Error("Please provide both username and API key.");
      }

      const response = await axios.get(`${BASE_URL}/api/connect`, {
        auth: {
          username: username,
          password: apiKey,
        },
      });

      if (response.data.http_code === 200) {
        onLogin(username, apiKey);
      } else {
        setMessage(response.message || "Login failed. Please try again.");
      }
    } catch (error) {
      setMessage(error.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md bg-white shadow-2xl rounded-2xl p-8 space-y-6">
      {/* Logo and Title Section */}
      <div className="flex flex-col items-center">
        <img src="/logo.svg" alt="ClickSend Logo" className="mb-4 w-64 h-16" />
        <h2 className="text-2xl font-bold text-center text-gray-800">
          Log in to access the upload portal
        </h2>
        <p className="text-sm text-center text-gray-500 mt-2">
          Use the upload portal to generate an image URL for your MMS message.
        </p>
      </div>

      {/* Username + API Key Input Form */}
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="username"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Username
          </label>
          <input
            type="text"
            id="username"
            name="username"
            placeholder="Your ClickSend username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            required
            disabled={loading}
          />
        </div>

        <div>
          <label
            htmlFor="apiKey"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            API Key
          </label>
          <input
            type="password"
            id="apiKey"
            name="apiKey"
            placeholder="Your ClickSend API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            required
            disabled={loading}
          />
        </div>

        <div className="text-sm text-red-500">{message}</div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full text-white font-semibold py-2 rounded-xl transition ${
            loading
              ? "bg-blue-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Logging in..." : "Log In"}
        </button>
      </form>

      {/* Instructions Section */}
      <div className="text-sm text-gray-600 pt-4 border-t">
        <h3 className="font-semibold mb-2">
          How to find your ClickSend API Key
        </h3>
        <ol className="list-decimal list-inside space-y-1 text-sm">
          <li>
            Log in to your{" "}
            <a
              href="https://dashboard.clicksend.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              ClickSend Dashboard
            </a>
          </li>
          <li>
            Navigate to <strong>Developers &rarr; API Credentials</strong>
          </li>
          <li>
            Copy your <strong>API Key</strong>
          </li>
          <li>Paste it above along with your ClickSend username</li>
        </ol>
      </div>
    </div>
  );
};

export default LoginView;
